import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "step1-container"
};
import { ref } from "vue";
import { ACCOUNT_TYPE } from "@/const";
export default {
  __name: 'step-1',
  emits: ["update:account-type"],
  setup(__props, {
    emit: __emit
  }) {
    const accountType = ref(ACCOUNT_TYPE.DIAMOND_ANNUAL);
    const emit = __emit;
    function onChange(val) {
      emit("update:account-type", val);
    }
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "step1-title"
      }, [_createTextVNode("Step "), _createElementVNode("span", null, "1"), _createTextVNode(":")], -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "step1-subtitle"
      }, "Tell us about your business", -1)), _createVNode(_component_el_radio_group, {
        modelValue: accountType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => accountType.value = $event),
        class: "step1-radio-group",
        onChange: onChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: _unref(ACCOUNT_TYPE).DIAMOND_ANNUAL
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("Single unit owner operator")])),
          _: 1,
          __: [1]
        }, 8, ["label"]), _createVNode(_component_el_radio, {
          label: _unref(ACCOUNT_TYPE).FLEET_MONTH
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("Multi-unit (2+) fleet operator")])),
          _: 1,
          __: [2]
        }, 8, ["label"])]),
        _: 1
      }, 8, ["modelValue"]), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "step1-divider"
      }, null, -1))]);
    };
  }
};